import angular from 'angular';
import summaryDataComponent from './summary-data.component';

export default angular.module('summaryData', []).component('summaryData', summaryDataComponent);



// WEBPACK FOOTER //
// ./client/pages/timesheet/components/summary-data/summary-data.js